import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';

import { DropdownValue } from '../shared/dropdown.model';

@Component({
    selector: 'user-types-selection',
    template: `<dropdown class="configurable-dropdown" [values]="userTypeValues" [selectedItem]="defaultUserTypeSelection" [prefix]="userTypePrefix" (valueChange)="onUserTypeValueChanged($event)" [useLightClass]="useLightClass"></dropdown>`
})
export class UserTypeSelectionComponent implements OnInit {
    userTypeValues: Array<DropdownValue> = [];
    userTypePrefix: string;

    @Input()
    defaultUserTypeSelection: DropdownValue;

    @Input()
    useLightClass: boolean = false;
    
    @Input()
    addAllSelection: boolean = false;

    @Input()
    displayPrefix: boolean = false;

    @Output()
    public userTypeChanged: EventEmitter<DropdownValue> = new EventEmitter<DropdownValue>();;

    constructor() {
        this.userTypeChanged 
    }

    ngOnInit() {
        if (this.displayPrefix)
            this.userTypePrefix = "User Type";

        if (this.addAllSelection)
            this.userTypeValues.push(new DropdownValue(0, 'All'));

        this.userTypeValues.push(new DropdownValue(1, 'SambaAdmin'));
        this.userTypeValues.push(new DropdownValue(2, 'PublisherAdmin'));
        // this.userTypeValues.push(new DropdownValue(3, 'ProviderAdmin'));

        if (!this.defaultUserTypeSelection) {
            this.defaultUserTypeSelection = this.userTypeValues[0];
        }
    }

    onUserTypeValueChanged(item: DropdownValue) {
        this.userTypeChanged.emit(item);
    }
}


// WEBPACK FOOTER //
// ./src/app/users/user-types-selection.component.ts